import React, { useRef, useEffect } from 'react';
import QRCode from 'qrcode';
import html2canvas from 'html2canvas';

const QRGenerator = ({ qrValue, closeDialog, texto = "", backgroundColor = "rgba(255,255,255,255)" }) => {
    const qrRef = useRef<HTMLDivElement>(null);


    useEffect(() => {
        if (qrRef.current) {
            QRCode.toCanvas(qrRef.current.querySelector('canvas'), qrValue, { width: 256 });
        }
    }, [qrValue]);

    const downloadQR = async () => {
        if (qrRef.current) {
            const canvas = await html2canvas(qrRef.current);
            const pngUrl = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
            const downloadLink = document.createElement("a");
            downloadLink.href = pngUrl;
            downloadLink.download = "qr_code.png";
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        }
    };

    return (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: backgroundColor }} tabIndex={-1}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className='p-3' style={{ display: 'flex', justifyContent: 'right' }} >
                        <button type="button" className="btn-close" onClick={closeDialog} aria-label="Close"></button>
                    </div>

                    <div className="modal-body" style={{ textAlign: 'center' }}>
                        <div>
                            <div ref={qrRef}>
                                <canvas />
                                <p>{texto}</p>
                            </div>

                        </div>
                    </div>
                    <div className='p-3' style={{ display: 'flex', justifyContent: 'center' }} >

                        <button className="btn btn-success" style={{ float: 'right' }} onClick={downloadQR}>Descargar QR</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default QRGenerator;
